<template>
	<v-dialog
			v-model="showDialog_"
			persistent
			width="600px">
		<template v-slot:activator="{ on }">
			<v-btn	class="customVBtn mr-2"
					color="error"
					depressed
					v-on="on">
				Undian
			</v-btn>
		</template>
		<template v-if="currentMode_ == 'top'">
			<v-card>
				<v-card-title>
					<v-row class="pt-3" justify="center">
						<v-col cols="auto">
							<h2><span style="font-family: 'Righteous', cursive; color: #ff5252">UNDIAN</span></h2>
						</v-col>
					</v-row>
				</v-card-title>
				<template v-for="(val, key) in lottery_">
					<v-card-actions :key="key">
						<v-row justify="center">
							<v-col cols="auto">
								<v-btn	color="#1E4C7C"
										dark
										depressed
										x-large
										@click="$_cstmBrLfLttryDlg_changeMode(val)">
									<span class="subtitle-2" v-text="lotteryTitle_[val]" />
								</v-btn>
							</v-col>
						</v-row>
					</v-card-actions>
				</template>
				<v-card-actions>
					<v-row class="pb-3" justify="center">
						<v-col cols="auto">
							<v-btn	color="#1E4C7C"
									text
									@click="$_cstmBrLfLttryDlg_closeDialog()">
								Tutup
							</v-btn>
						</v-col>
					</v-row>
				</v-card-actions>
			</v-card>
		</template>
		<template v-else>
			<v-card>
				<v-card-title>
					<v-row class="pt-3" justify="center">
						<v-col cols="auto">
							<h3><span style="font-family: 'Righteous', cursive;" v-text="lotteryTitle_[currentMode_]" /></h3>
						</v-col>
					</v-row>
				</v-card-title>
				<v-row justify="center">
					<v-col cols="auto">
						<h2><span style="font-family: 'Bungee Inline', cursive; color: #ff5252">2 0 0 6 0 4 -</span></h2>
					</v-col>
				</v-row>
				<v-row class="px-5" justify="space-around" no-gutters>
					<template v-for="(val, key) in randomNumber_[currentMode_]">
						<v-col :key="key" cols="auto">
							<v-row class="py-3" justify="center" no-gutters>
								<v-col cols="auto">
									<template v-if="openedNumber_[currentMode_][key]">
										<div :class="$_cstmBrLfLttryDlg_animateStyle(currentMode_)">
											<h1><span style="font-family: 'Bungee Inline', cursive; color: #ff5252" v-text="slotNumber_[currentMode_][key]" /></h1>
										</div>
									</template>
									<template v-else>
										<div><h1><span style="color: #ff5252">?</span></h1></div>
									</template>
								</v-col>
							</v-row>
							<v-row justify="center" no-gutters>
								<v-col cols="auto">
									<v-btn	color="#1E4C7C"
											:dark="!openedNumber_[currentMode_][key]"
											depressed
											small
											:disabled="openedNumber_[currentMode_][key]"
											@click="$_cstmBrLfLttryDlg_openNumber(currentMode_, key, val)">
										Undi
									</v-btn>
								</v-col>
							</v-row>
						</v-col>
					</template>
				</v-row>
				<template v-if="completedNumber_[currentMode_]['0'] && completedNumber_[currentMode_]['1'] && completedNumber_[currentMode_]['2'] && completedNumber_[currentMode_]['3'] && completedNumber_[currentMode_]['4']">
					<v-row class="pt-5" justify="center" no-gutters>
						<v-col cols="auto">
							<v-row class="py-3" justify="center" no-gutters>
								<v-col cols="auto">
									<template v-if="openedPerson_[currentMode_]">
										<v-row justify="center" no-gutters>
											<v-col cols="auto">
												<div :class="$_cstmBrLfLttryDlg_animateStyle(currentMode_)">
													<h1><span style="font-family: 'Righteous', cursive; color: #ff5252" v-text="randomPerson_[currentMode_].fullName" /></h1>
												</div>
											</v-col>
										</v-row>
										<v-row justify="center" no-gutters>
											<v-col cols="auto">
												<div :class="$_cstmBrLfLttryDlg_animateStyle(currentMode_)">
													<h2><span style="font-family: 'Righteous', cursive; color: #ff5252" v-text="randomPerson_[currentMode_].username" /></h2>
												</div>
											</v-col>
										</v-row>
										<v-row justify="center" no-gutters>
											<v-col cols="auto">
												<div :class="$_cstmBrLfLttryDlg_animateStyle(currentMode_)">
													<h2><span style="font-family: 'Righteous', cursive; color: #ff5252" v-text="randomPerson_[currentMode_].area" /></h2>
												</div>
											</v-col>
										</v-row>
									</template>
									<template v-else>
										<div><h1><span style="color: #ff5252">?</span></h1></div>
									</template>
								</v-col>
							</v-row>
							<v-row justify="center" no-gutters>
								<v-col cols="auto">
									<v-btn	color="#1E4C7C"
											:dark="!openedPerson_[currentMode_]"
											depressed
											small
											:disabled="openedPerson_[currentMode_]"
											@click="$_cstmBrLfLttryDlg_openPerson(currentMode_)">
										Pemenang Tiket Undian
									</v-btn>
								</v-col>
							</v-row>
						</v-col>
					</v-row>
				</template>
				<v-card-actions>
					<v-row class="py-3" justify="center">
						<v-col cols="auto">
							<v-btn	color="#1E4C7C"
									text
									@click="$_cstmBrLfLttryDlg_changeMode('top')">
								Kembali
							</v-btn>
						</v-col>
					</v-row>
				</v-card-actions>
			</v-card>
		</template>
	</v-dialog>
</template>

<script>
	export default {
		name: 'CustomBriLifeLotteryDialog',
		data() {
			return {
				showDialog_: false,

				currentMode_: 'top',

				lottery_: [ 'product1', 'product2', 'product3', 'product4', 'product5' ],

				lotteryTitle_: {
					product1: 'iPhone 12 Mini 64GB',
					product2: 'Laptop Lenovo Ideapad Slim i3',
					product3: 'Apple Watch Series 3',
					product4: 'Samsung Smartphone A31 (No.1)',
					product5: 'Samsung Smartphone A31 (No.2)'
				},

				slotNumber_: {
					product1: {
						'0': '?',
						'1': '?',
						'2': '?',
						'3': '?',
						'4': '?'
					},
					product2: {
						'0': '?',
						'1': '?',
						'2': '?',
						'3': '?',
						'4': '?'
					},
					product3: {
						'0': '?',
						'1': '?',
						'2': '?',
						'3': '?',
						'4': '?'
					},
					product4: {
						'0': '?',
						'1': '?',
						'2': '?',
						'3': '?',
						'4': '?'
					},
					product5: {
						'0': '?',
						'1': '?',
						'2': '?',
						'3': '?',
						'4': '?'
					}
				},

				randomNumber_: {
					product1: [0,2,1,0,8],
					product2: [0,1,7,6,2],
					product3: [0,2,4,1,8],
					product4: [0,2,7,2,7],
					product5: [0,2,6,8,9]
				},

				openedNumber_: {
					product1: {
						'0': false,
						'1': false,
						'2': false,
						'3': false,
						'4': false
					},
					product2: {
						'0': false,
						'1': false,
						'2': false,
						'3': false,
						'4': false
					},
					product3: {
						'0': false,
						'1': false,
						'2': false,
						'3': false,
						'4': false
					},
					product4: {
						'0': false,
						'1': false,
						'2': false,
						'3': false,
						'4': false
					},
					product5: {
						'0': false,
						'1': false,
						'2': false,
						'3': false,
						'4': false
					}
				},

				completedNumber_: {
					product1: {
						'0': false,
						'1': false,
						'2': false,
						'3': false,
						'4': false
					},
					product2: {
						'0': false,
						'1': false,
						'2': false,
						'3': false,
						'4': false
					},
					product3: {
						'0': false,
						'1': false,
						'2': false,
						'3': false,
						'4': false
					},
					product4: {
						'0': false,
						'1': false,
						'2': false,
						'3': false,
						'4': false
					},
					product5: {
						'0': false,
						'1': false,
						'2': false,
						'3': false,
						'4': false
					}
				},

				randomPerson_: {
					product1: { username: '9402011675779', fullName: 'Rizal Syafrudin', area : 'Semarang' },
					product2: { username: '60150208', fullName: 'Heni Meyrawati', area : 'Semarang' },
					product3: { username: '9601011474653', fullName: 'Ni Ketut Sri Suardani', area : 'Denpasar' },
					product4: { username: '9603011878294', fullName: 'Silfya Warow', area : 'Manado' },
					product5: { username: '9601011979266', fullName: 'Basyrun', area : 'Makassar' }
				},

				openedPerson_: {
					product1: false,
					product2: false,
					product3: false,
					product4: false,
					product5: false
				}
			}
		},
		computed: {
			$_cstmBrLfLttryDlg_stateUserGroup() {
				const self_ = this;
				return self_.getUserState('group')
			},
			$_cstmBrLfLttryDlg_animateStyle() {
				const self_ = this;
				return mode => {
					let style_ = null;
					if(mode == 'product1') { style_ = 'animate__animated animate__bounceInDown customAnimateStyle_'; }
					if(mode == 'product2') { style_ = 'animate__animated animate__flip customAnimateStyle_'; }
					if(mode == 'product3') { style_ = 'animate__animated animate__rollIn customAnimateStyle_'; }
					if(mode == 'product4') { style_ = 'animate__animated animate__zoomInDown customAnimateStyle_'; }
					if(mode == 'product5') { style_ = 'animate__animated animate__zoomInDown customAnimateStyle_'; }
					return style_
				}

			}
		},
		created() {
			const self_ = this;
			
			self_.$_cstmBrLfLttryDlg_getLocalStorage()
		},
		methods: {
			$_cstmBrLfLttryDlg_changeMode(mode) {
				const self_ = this;
				self_.currentMode_ = mode;
			},
			$_cstmBrLfLttryDlg_openNumber(mode, key, value) {
				const self_ = this;
				const maxIndex_ = 250;

				self_.openedNumber_[mode][key] = true;

				const set_ = index => {
					setTimeout(() => {
						if(index == maxIndex_) { 
							self_.slotNumber_[mode][key] = value;
							self_.completedNumber_[mode][key] = true;

							self_.$_cstmBrLfLttryDlg_setLocalStorage()
						}
						else { self_.slotNumber_[mode][key] = self_.getChanceInteger(0,9) }
					}, index*40)
				}

				for (let i = 1; i <= maxIndex_; i++) { set_(i) }
			},
			$_cstmBrLfLttryDlg_openPerson(name) {
				const self_ = this;
				self_.openedPerson_[name] = true;

				self_.$_cstmBrLfLttryDlg_setLocalStorage()
			},
			$_cstmBrLfLttryDlg_closeDialog() {
				const self_ = this;
				self_.showDialog_ = false;
			},
			$_cstmBrLfLttryDlg_getLocalStorage() {
				const self_ = this;

				const localStorage_ = self_.getLocalStorage('customBriLifeLotteryDialog')

				if(!self_.isEmpty(localStorage_)) {
					self_.openedNumber_ = localStorage_.openedNumber;
					self_.completedNumber_ = localStorage_.completedNumber;
					self_.slotNumber_ = localStorage_.slotNumber;
					self_.openedPerson_ = localStorage_.openedPerson;
				}
			},
			$_cstmBrLfLttryDlg_setLocalStorage() {
				const self_ = this;

				const localStorage_ = {
					openedNumber: self_.openedNumber_,
					completedNumber: self_.completedNumber_,
					slotNumber: self_.slotNumber_,
					openedPerson: self_.openedPerson_
				}

				self_.setLocalStorage('customBriLifeLotteryDialog', localStorage_)
			}
		}
	}
</script>

<style scoped>
	.customAnimateStyle_ {
		--animate-duration: 1.5s
	}
</style>